import React from 'react';
import { Row, Col, Tooltip } from 'antd';
import { EditOutlined, AuditOutlined, UserSwitchOutlined } from '@ant-design/icons';

const multiSelectFilter = (row, columnId, filterValue) => {
  if (!filterValue || filterValue.length === 0) return true;
  const val = row.getValue(columnId);
  const strVal = val != null ? String(val) : 'N/A';
  return filterValue.includes(strVal);
};

const USER_TYPE_LABELS = {
  admin: 'Admin',
  doctor: 'Doctor',
  clinicAdmin: 'Clinic Admin',
  biller: 'Biller',
  reviewer: 'Reviewer',
  scribe: 'Scribe'
};

export const createUserColumns = ({ onEditPassword, onViewLogs, onImpersonate, primaryColor }) => [
  {
    id: 'fullName',
    accessorKey: 'fullName',
    header: 'Name',
    size: 200,
    minSize: 100,
    maxSize: 400,
    enableSorting: true,
    filterFn: multiSelectFilter,
    cell: ({ getValue }) => {
      const val = getValue();
      if (!val) return 'N/A';
      return (
        <Tooltip title={val}>
          <span>{val.length > 30 ? `${val.slice(0, 30)}...` : val}</span>
        </Tooltip>
      );
    }
  },
  {
    id: 'email',
    accessorKey: 'email',
    header: 'Email',
    size: 240,
    minSize: 120,
    maxSize: 400,
    enableSorting: true,
    filterFn: multiSelectFilter,
    cell: ({ getValue }) => getValue() || 'N/A'
  },
  {
    id: 'userType',
    accessorFn: row => USER_TYPE_LABELS[row.userType] || row.userType || 'N/A',
    header: 'User Type',
    size: 140,
    minSize: 100,
    maxSize: 300,
    enableSorting: true,
    filterFn: multiSelectFilter,
    cell: ({ getValue }) => getValue()
  },
  {
    id: 'phoneNumber',
    accessorFn: row => {
      const ph = row.phoneNumber;
      if (!ph) return 'N/A';
      const num = ph.number || '';
      const code = ph.countryCode ? `+${ph.countryCode}` : '';
      return code && num ? `${code} ${num}` : num || 'N/A';
    },
    header: 'Phone',
    size: 180,
    minSize: 100,
    maxSize: 300,
    enableSorting: true,
    filterFn: multiSelectFilter,
    cell: ({ getValue }) => getValue()
  },
  {
    id: 'status',
    accessorKey: 'status',
    header: 'Status',
    size: 120,
    minSize: 80,
    maxSize: 200,
    enableSorting: true,
    filterFn: multiSelectFilter,
    cell: ({ getValue }) => getValue() || 'N/A'
  },
  {
    id: 'isEnabled',
    accessorFn: row => (row.isEnabled ? 'Enabled' : 'Disabled'),
    header: 'Enabled',
    size: 110,
    minSize: 80,
    maxSize: 200,
    enableSorting: true,
    filterFn: multiSelectFilter,
    cell: ({ getValue }) => getValue()
  },
  {
    id: 'isOnline',
    accessorFn: row => (row.isOnline ? 'Online' : 'Offline'),
    header: 'Online',
    size: 100,
    minSize: 80,
    maxSize: 200,
    enableSorting: true,
    filterFn: multiSelectFilter,
    cell: ({ getValue }) => {
      const val = getValue();
      return (
        <span style={val === 'Online' ? { color: primaryColor, fontWeight: 600 } : undefined}>
          {val}
        </span>
      );
    }
  },
  {
    id: 'actions',
    header: 'Action',
    size: 140,
    minSize: 120,
    maxSize: 200,
    enableSorting: false,
    enableColumnFilter: false,
    cell: ({ row }) => {
      const user = row.original;
      return (
        <Row gutter={12}>
          <Col>
            <Tooltip title='Update Password'>
              <EditOutlined
                style={{ fontSize: 18, cursor: 'pointer' }}
                onClick={() => onEditPassword(user)}
              />
            </Tooltip>
          </Col>
          <Col>
            <Tooltip title='View Logs'>
              <AuditOutlined
                style={{ fontSize: 18, cursor: 'pointer' }}
                onClick={() => onViewLogs(user)}
              />
            </Tooltip>
          </Col>
          <Col>
            <Tooltip title='Impersonate'>
              <UserSwitchOutlined
                style={{ fontSize: 18, cursor: 'pointer' }}
                onClick={() => onImpersonate(user)}
              />
            </Tooltip>
          </Col>
        </Row>
      );
    }
  }
];
